import { NEW_QUIZ_ATTEMPT_PAYLOAD_FIELDS } from "lib/experience-api/fragments";

export const NEW_QUIZ_ATTEMPT = `
  ${NEW_QUIZ_ATTEMPT_PAYLOAD_FIELDS}
  mutation NewQuizAttempt($input: NewQuizAttemptInput!) {
    newQuizAttempt(input: $input) {
      ...NewQuizAttemptPayloadFields
    }
  }
`;
